import React from 'react';

import ConceptDetails from 'scenes/Gallery/GalleryPage/Concepts/ConceptDetails';
import * as CONCEPT from 'scenes/Gallery/GalleryPage/Concepts/view-constants';
import CreativeDetails from 'scenes/Gallery/GalleryPage/Creatives/CreativeDetails';
import EditCreativeForm from 'scenes/Gallery/GalleryPage/Creatives/EditCreativeForm';
import MoveToForm from 'scenes/Gallery/GalleryPage/Creatives/MoveToForm';
import ShareCreativeForm from 'scenes/Gallery/GalleryPage/Creatives/ShareCreativeForm';
import {
  useActivate,
  useUnarchive,
  useArchive,
  useMoveToPreview,
  useRemove,
  useSwapWithOriginal,
  useCopyFileLink,
  useCopyNameKey,
  useDownloadFileLink,
  useExportCreatives,
} from 'scenes/Gallery/GalleryPage/Creatives/data';
import * as CREATIVE from 'scenes/Gallery/GalleryPage/Creatives/view-constants';
import { EXCEL, TAB_COMMENTS } from 'scenes/Gallery/GalleryPage/constants';

import Actions from './Actions';

const CreativesActions = ({
  actions,
  data,
  limit,
  onRemove,
  onOpenChildComponent,
  color,
  withAddComment = true,
}) => {
  const {
    [CREATIVE.ID]: id,
    [CREATIVE.NAME]: name,
    [CREATIVE.CONCEPT]: {
      [CONCEPT.ID]: conceptId,
      [CONCEPT.ORIGINAL_ID]: conceptOriginalId,
    },
  } = data;

  const [archiveCreative] = useArchive();
  const [unarchiveCreative] = useUnarchive();
  const [moveToPreviewCreative] = useMoveToPreview();
  const [activateCreative] = useActivate();
  const [removeCreative] = useRemove();
  const [swapCreativeWithOriginal] = useSwapWithOriginal();
  const copyFileLink = useCopyFileLink();
  const copyNameKey = useCopyNameKey();
  const downloadFileLink = useDownloadFileLink();
  const [exportExcelCreatives] = useExportCreatives({ type: EXCEL });

  const handleArchive = () => archiveCreative({ id, name });

  const handleUnarchive = () => unarchiveCreative({ id, name });

  const handleMoveToPreview = () => moveToPreviewCreative({ id, name });

  const handleActivate = () => activateCreative({ id, name });

  const handleCopyLink = () => copyFileLink({ id });

  const handleCopyNameKey = () => copyNameKey({ id });

  const handleDownload = () => downloadFileLink({ id });

  const handleExportToExcel = () => {
    return exportExcelCreatives({
      ids: [id],
      conceptId: conceptOriginalId,
    });
  };

  const handleEdit = () => onOpenChildComponent(EditCreativeForm, { id });

  const handleMoveTo = () => {
    onOpenChildComponent(MoveToForm, {
      id,
      onAddConcept: ({ [CONCEPT.ID]: conceptId }) => {
        onOpenChildComponent(ConceptDetails, {
          id: conceptId,
        });
      },
    });
  };

  const handleRemove = async () => {
    await removeCreative({ ids: [id], name });
    onRemove?.(data);
  };

  const handleShareManagement = () =>
    onOpenChildComponent(ShareCreativeForm, { id, name });

  const handleOpenOriginal = () =>
    onOpenChildComponent(CreativeDetails, { id: conceptOriginalId });

  const handleOpenComments = () => {
    onOpenChildComponent(CreativeDetails, {
      activeTabId: TAB_COMMENTS,
      id,
    });
  };

  const handleSwapWithOriginal = () =>
    swapCreativeWithOriginal({ id, conceptId });

  return (
    <Actions
      actions={actions}
      limit={limit}
      onEdit={handleEdit}
      onDelete={handleRemove}
      onArchive={handleArchive}
      onUnarchive={handleUnarchive}
      onMoveToPreview={handleMoveToPreview}
      onActivate={handleActivate}
      onCopyLink={handleCopyLink}
      onCopyNameKey={handleCopyNameKey}
      onDownload={handleDownload}
      onMoveTo={handleMoveTo}
      onExportToExcel={handleExportToExcel}
      onShare={handleShareManagement}
      onOpenOriginal={handleOpenOriginal}
      onSwapWithOriginal={handleSwapWithOriginal}
      onOpenComments={handleOpenComments}
      color={color}
      withAddComment={withAddComment}
    />
  );
};

export default CreativesActions;
